var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCwce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 57,
    viewBox: "0 0 54 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 57,
    fill: "url(#pattern0)",
    style: {
      mixBlendMode: "darken"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_356_28",
    transform: "scale(0.0185185 0.0175439)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_356_28",
    width: 54,
    height: 57,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA5CAIAAADycU9fAAABQGlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSCwoyGFhYGDIzSspCnJ3UoiIjFJgf8bAxiANxKYMoonJxQWOAQE+QCUMMBoVfLvGwAiiL+uCzJr/9WrQvUXzmA7aTrxjYrgxBFM9CuBKSS1OBtJ/gDgpuaCohIGBMQHIVi4vKQCxW4BskSKgo4DsGSB2OoS9BsROgrAPgNWEBDkD2VeAbIHkjMQUIPsJkK2ThCSejsSG2gsCHMGOvsGhfu4EnEo6KEmtKAHRzvkFlUWZ6RklCo7AEEpV8MxL1tNRMDIwMmJgAIU3RPX3RHA4MlY7IcRSNBkYjLYwMDAxI8QyyxkYdoUDvSyLENM0ZWAQ+srAsJe3ILEoEe4Axm8sxWnGRhC2JA8wuJv//39hwsDAW83A8O/t///fP/z//3sKAwO7LQNDTzcAk9ZdCuF/gbAAAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAADagAwAEAAAAAQAAADkAAAAAUtubTwAAAtFJREFUaAXVleFuwjAMhAfa+z8y7DoL63ZxHCdNBeMHchz77otD6e3xeHxd8Lnf77uU7xfgfYEPsvZ9Xn8/IpNxvMy6GbFlajOzrDsRz9OE9NsQE75kK2SS5DZE0ZXlGco9iBWCSo0czJYbEOve9UpmPYs46zpbD9ZTiAt+h+XvHzvPKY/XEWedmGOqdxEx98DbedcL+pg6H64YG98yhDXmh2SS26yT89U92M9imLpOuyuZuSm67hk+EKC9PssJxF18NqQ6ZRXR+eQWwiUmZEMKdzlpZSbOeY6riN6Ty3lZJWApjqW3hGj9OHEiJLrFJQR93j3xMeJ1fHYMpgwPNkB0vrB5YzL5UWb/i8xn8UYmkWJEv3qr6SJezSSIsmTKLqL0vHE5+C2ukeEGNl7CdwLBNjx55HkJBclgl3s5bhtDAC7rIoqrCOW7XJxX+mGYidsRxxc91GUVFPPyEH2N2QMpkGXCd6hJ9ZF6GbRbbaYt9owHbVeSQZfsdi9a6sLlGgRLGRBjtRNVRK5mLYuZiWPs2tKTCNp2z3gZMi2Tl1mQCUmpLFnaYjaW4jNLRWRj1oX9kIB7OZ7VgRG3xG8XKUIDW4asvSSbtTqya0v2QiZGDDvflfwz0ndB5L5zT3SutXfXr1sRzca397rW1fhh+MSLlicveFz4BPVz763kawwQYcbnkBi73L9AZoIi65qcN/EuYuLtcklNsgWIZBdbot99XEzIq/1wQ4Pc3nZbWeTF0XViRN9mII69YC1gKY5Dte7M/aBoQ2yfUGIhCbVQ1vIiGP8WvSg8YijkLcMg1LSuULk7Re7hQw8JKgUQtA+KEbBX2z6YojXIuV20latkRA0tueBgimaZS1SwpIYFOZYyW5YQUToUCtV7SR9kRbZ00ew0pc6NFi+0TyOKE5aVSThZsd5c7HsR0ZrZmEV7ceUwbe/t+Xy22Y/KVB+XN0L/A8QfPvSSW0kwQtIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwce);
export default __webpack_public_path__ + "static/media/cwce.358e16ab8eb5c2b3407ce28398185a28.svg";
export { ForwardRef as ReactComponent };